export default "__VITE_ASSET__7f73c502__"